import PlanPageConstants from '../components/pages/PlanPage/PlanPageConstants';
import { isMacOS } from './browserUtilities';

export function allFirstToUpper(input) {
    return input.toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
}

export function getCurrencyDisplayName(currency) {
    switch(currency) {
        case PlanPageConstants.CURRENCIES.USD: 
            return 'USD'; 
        case PlanPageConstants.CURRENCIES.EUR: 
            return 'EUR'; 
        case PlanPageConstants.CURRENCIES.GBP: 
            return 'GBP'; 
    }
    return '';
}

export function getCurrencySymbol(currency) {
    switch(currency) {
        case PlanPageConstants.CURRENCIES.USD: 
            return '$'; 
        case PlanPageConstants.CURRENCIES.EUR: 
            return '€'; 
        case PlanPageConstants.CURRENCIES.GBP: 
            return '£'; 
    }
    return '';
}

export function getOrdinalSuffix(number) {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return 'th';
    }

    switch (lastDigit) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}

export function getPurchaseOptionDisplayName(planType, purchaseOptionName) {
    switch(planType) {
        case PlanPageConstants.PLAN_TYPES.UNLIMITED:
            return 'Unlimited';
        case PlanPageConstants.PLAN_TYPES.PRO:
            return 'Pro';
    }
    return purchaseOptionName;
}
export function getOSCommandKeyName() {
    return isMacOS() ? 'Option' : 'Ctrl';
}

export function containsEmojis(text) {
    const rgiEmojiRegex = /(?:\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}(?:\uFE0F|(?=\p{Emoji_Modifier})))\p{Emoji_Modifier}?(?:\u200D(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}(?:\uFE0F|(?=\p{Emoji_Modifier})))\p{Emoji_Modifier}?)*)/u;
    return rgiEmojiRegex.test(text);
};

export function extractEmojis(text) {
    const rgiEmojiRegex = /(?:\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}(?:\uFE0F|(?=\p{Emoji_Modifier})))\p{Emoji_Modifier}?(?:\u200D(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}(?:\uFE0F|(?=\p{Emoji_Modifier})))\p{Emoji_Modifier}?)*)/gu;
    const matches = text.match(rgiEmojiRegex);
    return matches || [];
}

export function emojiToUnicode(emoji) {
    if (!emoji || emoji.length === 0) {
        return "";
    }
    // For a combined emoji, we will create a string of all its code points
    // in the format U+XXXX-U+YYYY-...
    // This will ensure a unique identifier for each visual sequence.
    return Array.from(emoji)
        .map(char => `U+${char.codePointAt(0).toString(16).toUpperCase()}`)
        .join('-');
}

// Splits a trailing file extension (".mp3") from the name but keeps dots elsewhere in it, so
// "Vol. 2 - Intro.mp3" becomes "Vol. 2 - Intro" + ".mp3" and a name without an extension is left alone.
export function splitFileExtension(fileName) {
    const name = fileName || '';

    // An extension has a letter in it, so a version suffix like "v1.5" is not mistaken for one.
    const extensionMatch = name.match(/\.(?=[A-Za-z0-9]*[A-Za-z])[A-Za-z0-9]{1,5}$/);
    const extension = extensionMatch ? extensionMatch[0] : '';

    return { baseName: name.slice(0, name.length - extension.length), extension };
}

export function removeFileExtension(fileName) {
    return splitFileExtension(fileName).baseName;
}
